import Vue from 'vue'
import Toasted from 'vue-toasted'
Vue.use(Toasted, {
  duration: '2000',
  position: 'bottom-right',
  keepOnHover: true
})
